import React from "react"
import { useState } from "react"
import styled from "styled-components"
import { BsArrowLeft } from "react-icons/bs"
import video from "../assets/intro.mp4"
import { useNavigate } from "react-router-dom"

export default function Player() {

  const navigate = useNavigate();

  return (
    <Container>
      <div className="player">
        <div className="back">
          <BsArrowLeft onClick={() => navigate(-1)}/>
        </div>
        <video src={video} loop muted controls autoPlay></video>
      </div>
    </Container>
  )
}

const Container = styled.div`
  .player{
    width: 100vw;
    height: 100vh;

    .back{
      position: absolute;
      padding: 2rem;
      z-index: 1;
      svg{
        font-size: 2rem;
        cursor: pointer;
      }
    }
    video{
      height: 100%;
      width: 100%;
      object-fit: cover; 
    }
  }
`;